import React, { useEffect, useState } from 'react'
import { FaXmark } from 'react-icons/fa6';
import AssortmentPopover from '../popover/AssortmentPopover';
import AssortmentPopoverBottom from '../popover/AssortmentPopoverBottom';
import Notification from '../utility/Notification';
import { getRecentInstalmentByTicketId, saveRegularTicketInstalment } from '../../service/RegularTicketInstalmentService';

function TicketUpdateSlideBar({updatingTicket}) {

  const loggedUser = JSON.parse(
    atob(sessionStorage.getItem("x$sk72hyQwersgyhk"))
  );

  const [isOpenSlideBar, setIsOpenSlideBar] = useState(false);
  const [ticket, setTicket] = useState('')
  
  useEffect(()=>{
    initialize()
    setApiResponse({})

    if(updatingTicket){
      setTicket(updatingTicket.data)
      setIsOpenSlideBar(true);
      fetchOverdue(updatingTicket.data.id)
      
    }else{
      setTicket('')
      setIsOpenSlideBar(false);
    }
  },[updatingTicket]);


  const fetchOverdue = async(ticketId) =>{
      let res = await getRecentInstalmentByTicketId(loggedUser.token,ticketId);
      if(res.data != null){
        setInstalmentFormData((prevState) => ({ ...prevState, ['overdue']: res.data.balance }));
      }      
  }

  const [apiResponse, setApiResponse] = useState({
    //status: true, data: null, message: 'Already added : Fabric'
    status: "",
    message: "",
  });


  // Inputs
  const [instalmentFormData, setInstalmentFormData] = useState({
    id: '',
    refNo: '',
    total: 0,   
    paid: '',
    balance: 0,
    additional: 0,
    overdue: 0,
    paymentStatus: '',
    paidDate: '',

    assortmentId: 0,   
    
    errors: {},
  });
  

  
  const handleInstalmentInputChange = (e) => {
    const { name, value } = e.target;
    if(name=='paid'){
      let balance = instalmentFormData.total-value;
      setInstalmentFormData((prevState) => ({ ...prevState, ['balance']: balance }));

      if(balance === 0){
        setInstalmentFormData((prevState) => ({ ...prevState, ['paymentStatus']: 'FULL PAID' }));
      }else if(instalmentFormData.paid == 0){
        setInstalmentFormData((prevState) => ({ ...prevState, ['paymentStatus']: 'NOT PAID' }));
      }else{
        setInstalmentFormData((prevState) => ({ ...prevState, ['paymentStatus']: 'PARTIALLY PAID' }));
      }
    }
    setInstalmentFormData((prevState) => ({ ...prevState, [name]: value }));    
  };


  // for Validation
  const [isValidPaidDate, setIsValidPaidDate] = useState(true);
  const [isValidAssortmentCode, setIsValidAssortmentCode] = useState(true);
  const [isValidPaid, setIsValidPaid] = useState(true);
  
  // change input validation state
  const setIsValidInputs = (isValid) => {
    setIsValidPaidDate(isValid);
    setIsValidAssortmentCode(isValid);
    setIsValidPaid(isValid);       
  };

  // clear inputs
  const clearFormInputs = () => {
    setInstalmentFormData({
      id: '',
      refNo: '',
      total: 0,   
      paid: '',
      balance: 0,
      additional: 0,
      overdue: 0,
      paymentStatus: '',
      paidDate: '',

      assortmentId: 0,          
    
    errors: {},
    });
    
  };

  // initialize inputs and state
  const initialize = () => {   
    clearFormInputs();    
    setIsValidInputs(true); 
    setTicket('')
    setIsAssortmentClear(true)  
  };


  const handlePayButton = async (e) => {    
    e.preventDefault();
    setIsValidInputs(true)

    let instalment = {
      id: instalmentFormData.id,
      refNo: '',
      total: instalmentFormData.total,
      paid: instalmentFormData.paid,
      balance: instalmentFormData.balance,
      paymentStatus: instalmentFormData.paymentStatus.replace(' ','_'),
      paidDate: instalmentFormData.paidDate,
      ticketId: ticket.id,
      assortmentId: instalmentFormData.assortmentId
    }

    let res = null
    if(isValidInputs()){
      res = await saveRegularTicketInstalment(loggedUser.token,instalment)
      if(res != null){
        initialize()
        setIsOpenSlideBar(false)   
      } 

    }else{
        setApiResponse({ status: false, message: "Invalid Inputs..." });
      }   
    
  }


  const isValidInputs = () =>{
    const errors = {};

    if(!instalmentFormData.paidDate){
      setIsValidPaidDate(false)
      errors.paidDate = 'Paid Date is Required'
    }

    if(!instalmentFormData.assortmentId){
      setIsValidAssortmentCode(false)
      errors.assortmentCode = 'Assortment Code is Required'
    }

    if(!instalmentFormData.paid){
      setIsValidPaid(false)
      errors.paid = 'Paid is Required'
    }

    setInstalmentFormData((prevState) => ({ ...prevState, errors }));

    console.log(errors)
    
    // return true if there are no errors
    return Object.keys(errors).length === 0;

  }



  //++++++++++++++ Popovers ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
  const [isAssortmentClear, setIsAssortmentClear] = useState(false);

  const handleSelectAssortment = async (assortment) =>{
    
    setInstalmentFormData((prevState) =>({
      ...prevState,      
      assortmentId: assortment.id,      
      planValueId: assortment.planValueId,
      planValue: assortment.value,
      additional: assortment.value - ticket.instalmentValue,
      total: assortment.value  + instalmentFormData.overdue
    }))    

    setIsAssortmentClear(false)         
  }

  //++++++++++++++ End Popovers ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
  
  return (
    <div>
      { ticket &&
        <div
          className={`absolute top-10 right-0 h-[93.5%] w-1/4 bg-white drop-shadow-[-4px_0_4px_rgba(0,0,0,0.1)] transition-transform duration-2000 ${
            isOpenSlideBar ? 'translate-x-0' : 'translate-x-full hidden'
          }`}                
        >  
          <div><button className="p-1" onClick={()=> setIsOpenSlideBar(false)}><FaXmark size={17} className="text-blue-700"/></button></div>
          <div className="px-2">
            <h2 className="font-semibold">
              <span className='pl-1'>Ticket Updating :</span>
              <span className='pl-2 text-master_color-600'>{ticket?ticket.ticketCode:''}</span>             
            </h2>
            <hr className='border-slate-300 border-0.5'></hr>
            <div className="grid px-1">              
              <div id='row-1'>
                <div className="text-master_color-300 text-base font-semibold drop-shadow-sm mt-2">Current Instalment</div>                 
                <div className="grid grid-cols-4 mt-1">
                  <div className="pt-1 text-sm font-sans drop-shadow">Date</div>
                  <div className="col-span-2">
                    <input
                      type="date"
                      name="paidDate"
                      value={instalmentFormData.paidDate}
                      onChange={handleInstalmentInputChange}                     
                      className={`w-full text-sm pl-2 py-1 bg-white outline-none border  focus:border-master_color-200 rounded
                            ${
                              isValidPaidDate
                                ? "border-slate-400"
                                : "border-red-600"
                            }                        
                        `}
                    />
                  </div>
                </div> 
                <div className="grid grid-cols-4 mt-1">
                  <div className="pt-1 text-sm font-sans drop-shadow">Assortment</div>
                  <div className="col-span-2">
                    <AssortmentPopoverBottom 
                      onSelectAssortment={handleSelectAssortment} 
                      isAssortmentClear={isAssortmentClear}
                      setAssortCode={instalmentFormData.assortmentCode}
                    />
                  </div>
                </div> 
                <div className="grid grid-cols-4 mt-5">
                  <div className="pt-1 text-sm font-sans drop-shadow">Instalment</div>
                  <div className="col-span-2">
                    <input
                      type="text"                                           
                      value={ticket.instalmentValue}                     
                      placeholder="Required"
                      disabled={true}
                      className={`w-full text-sm pl-2 py-0.5 outline-none border  focus:border-master_color-200 rounded bg-white border-slate-400`}                        
                    />
                  </div>
                </div>
                <div className="grid grid-cols-4 mt-1">
                  <div className="pt-1 text-sm font-sans drop-shadow">Additonal</div>
                  <div className="col-span-2">
                    <input
                      type="text"
                      name='additional'                     
                      value={instalmentFormData.additional}                     
                      placeholder="Required"
                      disabled={true}
                      className={`w-full text-sm pl-2 py-0.5 outline-none borderfocus:border-master_color-200 rounded bg-white border-slate-400`}                        
                    />
                  </div>
                </div>
                <div className="grid grid-cols-4 mt-1">
                  <div className="pt-1 text-sm font-sans drop-shadow">Overdue</div>
                  <div className="col-span-2">
                    <input
                      type="text"
                      name="overdue"                     
                      value={instalmentFormData.overdue} 
                      onChange={handleInstalmentInputChange}                    
                      placeholder="Required"
                      disabled={true}
                      className={`w-full text-sm pl-2 py-0.5 outline-none border  focus:border-master_color-200 rounded bg-white border-slate-400`}                        
                    />
                  </div>
                </div>
                <div className="grid grid-cols-4 mt-5">
                  <div className="pt-1 text-base font-semibold font-sans drop-shadow">Total</div>
                  <div className="col-span-2">
                    <input
                      type="text"
                      name='total'
                      onChange={handleInstalmentInputChange}                     
                      value={instalmentFormData.total}                     
                      placeholder="Required"
                      disabled={true}
                      className={`w-full text-base font-semibold pl-2 py-0.5 outline-none border  focus:border-master_color-200 rounded bg-white border-slate-400`}                        
                    />
                  </div>
                </div>
                <div className="grid grid-cols-4 mt-1">
                  <div className="pt-1 text-base font-semibold font-sans drop-shadow">Paid</div>
                  <div className="col-span-2">
                    <input
                      type="number"
                      name='paid'
                      onChange={handleInstalmentInputChange}                     
                      value={instalmentFormData.paid}                     
                      placeholder="Required"
                      disabled={false}
                      className={`w-full text-base font-semibold pl-2 py-0.5 outline-none border  focus:border-master_color-200 rounded bg-white
                              ${
                                isValidPaid
                                  ? "border-slate-400"
                                  : "border-red-600"
                              }   
                              `}                        
                    />
                  </div>
                </div>
                <div className="grid grid-cols-4 mt-1">
                  <div className="pt-1 text-base font-semibold font-sans drop-shadow">Balance</div>
                  <div className="col-span-2">
                    <input
                      type="number"
                      name='balance'
                      onChange={handleInstalmentInputChange}                     
                      value={instalmentFormData.balance}                     
                      placeholder="Required"
                      disabled={true}
                      className={`w-full text-base font-semibold pl-2 py-0.5 outline-none border  focus:border-master_color-200 rounded bg-white border-slate-400`}                        
                    />
                  </div>
                </div>
                <div className="grid grid-cols-4 mt-1">
                  <div className="pt-1 text-base  font-sans drop-shadow">Status</div>
                  <div className="col-span-2">
                    <input
                      type="text"
                      name='paymentStatus'
                      onChange={handleInstalmentInputChange}                     
                      value={instalmentFormData.paymentStatus}                     
                      placeholder=""
                      disabled={true}
                      className={`w-full text-base  pl-2 py-0.5 outline-none border  focus:border-master_color-200 rounded bg-white border-slate-400`}                        
                    />
                  </div>
                </div>                  
              </div>
              <div id='row-2' className={`mt-5`}>                                
                <div className="grid grid-cols-1 py-1 px-[20%]">                  
                  <button
                    type="button"
                    onClick={handlePayButton}
                    className="py-1.5 text-sm font-medium rounded text-white  items-center bg-master_color-400 hover:bg-master_color-200"
                  >                    
                    Confirm & Pay
                  </button>
                </div>  
                <div className="grid grid-cols-1 py-1 px-[20%] items-center">
                  <span className="py-1.5 px-[20%] font-medium text-center">
                    <Notification response={apiResponse}/>
                  </span>                
                </div>                         
              </div>
            </div>           
          </div>
        </div>
      }
    </div>
  )
}

export default TicketUpdateSlideBar